/* eslint-disable no-unused-vars */
import ReactDOM from "react-dom";
import CryptoJS from "crypto-js";

import { clevertap_id } from "./App";
// clever tap
import clevertap from "clevertap-web-sdk";

import moment from "moment-timezone";
import { RolesAndAccessActions } from "./redux-store/store";
import { useDispatch } from "react-redux";
import { GetRolesAndAccess } from "./apiServices";
import { toast } from "react-toastify";
import greengif from "./assets/images/imgpsh_fullsize_anim (1).gif";

const Dispatch = useDispatch;

// time ago function
export function TimeAgo(props) {
  let date = new Date(props.dateValue);
  var seconds = Math.floor((new Date() - date) / 1000);

  var interval = seconds / 31536000;

  if (interval > 1) {
    return Math.floor(interval) + " year(s)";
  }
  interval = seconds / 2592000;
  if (interval > 1) {
    return Math.floor(interval) + " month(s)";
  }
  interval = seconds / 86400;
  if (interval > 1) {
    return Math.floor(interval) + " day(s)";
  }
  interval = seconds / 3600;
  if (interval > 1) {
    return Math.floor(interval) + " hour(s)";
  }
  interval = seconds / 60;
  if (interval > 1) {
    return Math.floor(interval) + " min(s)";
  }
  return Math.floor(seconds) + " sec(s)";
}

export function TimeAgoPlusFiveHours(props) {
  let date = new Date(props.dateValue);
  var seconds = Math.floor((new Date() - date) / 1000);

  // Add 5 hours and 30 minutes to the calculated time difference
  seconds -= 5 * 3600 + 30 * 60;

  var interval = seconds / 31536000;

  if (interval > 1) {
    return Math.floor(interval) + " year(s)";
  }
  interval = seconds / 2592000;
  if (interval > 1) {
    return Math.floor(interval) + " month(s)";
  }
  interval = seconds / 86400;
  if (interval > 1) {
    return Math.floor(interval) + " day(s)";
  }
  interval = seconds / 3600;
  if (interval > 1) {
    return Math.floor(interval) + " hour(s)";
  }
  interval = seconds / 60;
  if (interval > 1) {
    return Math.floor(interval) + " min(s)";
  }
  return Math.floor(seconds) + " sec(s)";
}

export function DynamicTimeAgo(baseTime, hours, minutes) {
  const adjustedTime = moment(baseTime)
    .add(hours, "hours")
    .add(minutes, "minutes");

  const now = moment();
  const timeDifference = now.diff(adjustedTime, "milliseconds");

  const thresholds = [
    { threshold: 3600 * 1000, unit: "hours", singular: "hour" },
    { threshold: 60 * 1000, unit: "minutes", singular: "minute" },
    { threshold: 1000, unit: "seconds", singular: "second" },
  ];

  for (const { threshold, unit, singular } of thresholds) {
    const difference = Math.floor(timeDifference / threshold);
    if (difference >= 1) {
      return `${difference} ${difference === 1 ? singular : unit} ago`;
    }
  }

  // If less than a second ago, display "just now"
  return "just now";
}
export function MyModal(props) {
  return ReactDOM.createPortal(
    props.children,
    document.getElementById("modal-root")
  );
}
export function Detailsshow(props) {
  return ReactDOM.createPortal(
    props.children,
    document.getElementById("modal-root1")
  );
}
// change date format
export function Ddmmmyyyy_date({ dateValue }) {
  const istTime = moment(dateValue)
    .tz("Asia/Kolkata")
    .format("DD-MMM-YYYY hh:mm A");
  return istTime;
}

export function Date_Date({ dateValue }) {
  const istTime = moment(dateValue)
    .tz("Asia/Kolkata")
    .format("DD-MM-YYYY hh:mm A");
  return istTime;
}
export function dateAndTimeFormate({ dateValue }) {
  const istTime = moment(dateValue)
    .tz("Asia/Kolkata")
    .format("YYYY-MM-DD hh:mm:ss");
  return istTime;
}
export function dateAndTimeHHMMSS(dateValue) {
  const istTime = moment(dateValue)
    .tz("Asia/Kolkata")
    .format("YYYY-MM-DD hh:mm:ss");
  return istTime;
}
// const moment = require("moment-timezone");

export function startOfDayInIST(dateValue) {
  const startOfDay = moment(dateValue)
    .tz("Asia/Kolkata")
    .startOf("day")
    .format("YYYY-MM-DD HH:mm:ss");
  return startOfDay;
}

export function endOfDayInIST(dateValue) {
  const endOfDay = moment(dateValue)
    .tz("Asia/Kolkata")
    .endOf("day")
    .format("YYYY-MM-DD HH:mm:ss");
  return endOfDay;
}

const scheduledStart = startOfDayInIST(new Date());
const scheduledEnd = endOfDayInIST(new Date());

//console.log("Scheduled Start:", scheduledStart);
//console.log("Scheduled End:", scheduledEnd);
export function dateFormate(dateValue) {
  const istTime = moment(dateValue).tz("Asia/Kolkata").format("YYYY-MM-DD");
  return istTime;
}
export function dateFormateDD(dateValue) {
  const istTime = moment(dateValue).tz("Asia/Kolkata").format("DD-MM-YYYY ");
  return istTime;
}
export function DMMMYYYY_formate({ dateValue }) {
  // 18-Aug-2023 Component
  const istTime = moment(dateValue).tz("Asia/Kolkata").format("DD-MMM-YYYY ");
  return istTime;
}

export function dMMMYYYY_formate(dateValue) {
  // 18-Aug-2023 function
  const istTime = moment(dateValue).tz("Asia/Kolkata").format("DD-MMM-YYYY ");
  return istTime.trim();
}
export function getDateOnly(isoString) {
  if (!isoString) return "";
  const date = new Date(isoString);
  return date.toISOString().split("T")[0];
}

export function MonthDate(dateValue) {
  // 18-Aug-2023 function
  const istTime = moment(dateValue).tz("Asia/Kolkata").format("MMM DD ");
  return istTime.trim();
}
export function Dateyear(dateValue) {
  // 18-Aug-2023 function
  const istTime = moment(dateValue).tz("Asia/Kolkata").format("DD, YYYY ");
  return istTime.trim();
}

export function DDMMYYYY_formate({ dateValue }) {
  const istTime = moment(dateValue)
    .tz("Asia/Kolkata")
    .format("DD-MM-YYYY hh:mm A");

  return istTime;
}

export function addHoursAndMinutesToDate(hours, mins, input) {
  // Make a copy of the input date to avoid modifying the original date
  var newDate = new Date(input);

  // Add 5 hours and 30 minutes
  newDate.setHours(newDate.getHours() + hours);
  newDate.setMinutes(newDate.getMinutes() + mins);

  return newDate;
}

export function MMMMDDYYYY_formate({ dateValue }) {
  const options = {
    day: "numeric",
    year: "numeric",
    month: "short",
  };
  const timer = {
    hour: "2-digit",
    minute: "2-digit",
  };
  const date = new Date(dateValue);
  const formattedDate = date.toLocaleDateString("en-US", options);
  const time = date.toLocaleTimeString("en-US", timer);

  return `${formattedDate}, ${time}`;
}

export function Weekday_MMDDYYY({ dateValue }) {
  const istTime = moment(dateValue)
    .tz("Asia/Kolkata")
    .format("ddd , DD-MMM-YYYY");

  return istTime;
}

export function formatMonthYear(date) {
  return new Date(date)
    .toLocaleString("en-US", {
      month: "short",
      year: "numeric",
    })
    .toUpperCase(); // returns "APR 2025"
}

export const getStageName = (id) => {
  const map = {
    8: "Scheduled",
    14: "Attended",
    18: "Selected",
    22: "Offer Accepted",
    27: "Joined",

    // Exit stages
    26: "Not Interested",
    21: "Not Selected",
    25: "Offer Rejected",
    29: "Left",
    30: "Lead Lost"
  };

  return map[id] || `Stage ${id}`;
};

export const formatDateTime = (dateString) => {
  if (!dateString) return "N/A";

  const date = new Date(dateString);

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");

  const ampm = hours >= 12 ? "pm" : "am";

  hours = hours % 12;
  hours = hours ? hours : 12; // 0 → 12

  const formattedTime = `${String(hours).padStart(2, "0")}:${minutes} ${ampm}`;

  return `${day}/${month}/${year} ${formattedTime}`;
};


export const dialPhoneNumber = (phoneNumber) => {
  const formattedNumber = phoneNumber.replace(/\D/g, ""); // Remove non-digits
  window.location.href = `tel:${formattedNumber}`;
};

export const openWhatsApp = (phoneNumber, message = "") => {
  const formattedNumber = phoneNumber.replace(/\D/g, ""); // Remove non-digits
  const encodedMessage = encodeURIComponent(message);
  window.open(`https://wa.me/${formattedNumber}?text=${encodedMessage}`, "_blank");
};
export const copyToClipboard = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    toast.success("Copied to clipboard!");
  } catch (err) {
    console.log(err);
    
    toast.error("Copy failed");
  }
};

// export const calculateAge = (dob) => {
//   if (!dob) return "N/A";

//   const birthDate = new Date(dob);
//   const today = new Date();

//   let age = today.getFullYear() - birthDate.getFullYear();

//   const monthDiff = today.getMonth() - birthDate.getMonth();

//   // If birthday not yet reached this year
//   if (
//     monthDiff < 0 ||
//     (monthDiff === 0 && today.getDate() < birthDate.getDate())
//   ) {
//     age--;
//   }

//   return age;
// };
// clever tap

export function CleverTapInit(name, email) {
  // //console.log(clevertap_id);
  // //console.log(name, email);
  clevertap.init(clevertap_id);
  // for profile creation
  clevertap.onUserLogin.push({
    Site: {
      Name: name, // String
      Identity: email, // String or number
      Email: email, // Email address of the user
      // Phone: "+16383465436", // Phone (with the country code)
      // Gender: "M", // Can be either M or F
      loginTime: new Date(), // Date of Birth. Date object
      // optional fields. controls whether the user will be sent email, push etc.
      "MSG-email": true, // Disable email notifications
      "MSG-push": true, // Enable push notifications
      "MSG-sms": true, // Enable sms notifications
      "MSG-whatsapp": true, // Enable WhatsApp notifications
    },
  });

  // for event
  // clevertap.event.push("My New Web Push Message Campaign", {
  //   "Product name": "Casio Chronograph Watch",
  //   Category: "Mens Accessories",
  //   Price: 59.99,
  //   Date: new Date(),
  // });

  // for web push permission
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.register("./clevertap_sw.js");
  }

  clevertap.notifications.push({
    apnsWebPushId: "<apple web push id>", //only for safari browser
    apnsWebPushServiceUrl: "<safari package service url>", //only for safari browser
    titleText: "Would you like to receive Push Notifications?",
    bodyText:
      "We promise to only send you relevant content and give you updates on your transactions",
    okButtonText: "Sign me up!",
    rejectButtonText: "No thanks",
    okButtonColor: "#f28046",
  });

  //console.log("cleverTap called");
}

export const strictNumberValidator = (value, maxLength) => {
  if (value.trim() === "") {
    return true; // Allow empty values
  }
  return /^\d+$/.test(value) && value.length <= maxLength;
};

export function convertDateYYYYMMDD(dateString) {
  //console.log(dateString);
  const dateObj = new Date(dateString);
  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, "0");
  const day = String(dateObj.getDate()).padStart(2, "0");
  const formattedDate = `${year}-${month}-${day}`;

  //console.log(formattedDate);

  return formattedDate;
}

export function convertDateDDMMYYY(dateString) {
  //console.log(dateString);
  const dateObj = new Date(dateString);
  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, "0");
  const day = String(dateObj.getDate()).padStart(2, "0");
  const formattedDate = `${day}-${month}-${year}`;

  //console.log(formattedDate);

  return formattedDate;
}
export function convertTime(dateString) {
  //console.log(dateString);
  const dateObj = new Date(dateString);
  const hours = String(dateObj.getHours() % 12 || 12).padStart(2, "0");
  const minutes = String(dateObj.getMinutes()).padStart(2, "0");
  const seconds = String(dateObj.getSeconds()).padStart(2, "0");
  const ampm = dateObj.getHours() >= 12 ? "PM" : "AM";
  const formattedDate = `${hours}:${minutes} ${ampm}`;

  //console.log(formattedDate);

  return formattedDate;
}

const handlePhoneIconClick = (phoneNumber) => {
  window.location.href = `tel:${phoneNumber}`;
};
const handleWhatsAppIconClick = (phoneNumber) => {
  // //console.log(event)
  const whatsappURL = `https://api.whatsapp.com/send?phone=${phoneNumber}`;
  window.open(whatsappURL, "_blank");
};

export function gstTest(val) {
  const gstRegex = /^\d{2}[A-Z]{5}\d{4}[A-Z]{1}\d[Z]{1}[A-Z\d]{1}$/;
  return gstRegex.test(val);
}

export function alphabetTest(val) {
  const Regex = /^[a-zA-Z\s]*$/;
  return Regex.test(val);
}

export function alphabetWithSpecialCharacterTest(val) {
  const regex = /^[a-zA-Z\s!@#$%^&*()\-_=+[{\]};:'",<.>/?]*$/;
  return regex.test(val);
}

export function numbersOnlyTest(val) {
  const regex = /^[0-9]*$/;
  return regex.test(val);
}

export function numbersOnlyWithDOtTest(val) {
  const regex = /^[0-9.]*$/;
  return regex.test(val);
}

export function alphanumericTest(val) {
  const regex = /^[a-zA-Z0-9]*$/;
  return regex.test(val);
}
export function emailValidation(val) {
  const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return regex.test(val);
}
export function uppercaseOnlyTest(val) {
  const regex = /^[A-Z]*$/;
  return regex.test(val);
}

export const addDaysToDate = (days) => {
  const currentDate = new Date();
  const futureDate = new Date();
  futureDate.setDate(currentDate.getDate() + days);

  return futureDate;
};
export const minusDaysToDate = (days) => {
  const currentDate = new Date();
  const futureDate = new Date();
  futureDate.setDate(currentDate.getDate() - days);

  return futureDate;
};
// export const extendOneWeek = (days) => {
//   const currentDate = new Date();
//   const futureDate = new Date();
//   futureDate.setDate(currentDate.getDate() - days);

//   return futureDate;
// };
export const DaysToDate = (days) => {
  const currentDate = new Date();
  const futureDate = new Date();
  futureDate.setDate(currentDate.getDate() - days);

  return futureDate;
};

export function subDaysToDate(days) {
  const currentDate = new Date();
  const pastDate = new Date();
  pastDate.setDate(currentDate.getDate() - days);

  return pastDate.toISOString().split("T")[0];
}

export function textTruncate(text, length) {
  return text
    ? text.length > length
      ? text.substring(0, length) + " ...."
      : text
    : "";
}

export function capitalizeWords(str) {
  return str ? str.replace(/\b\w/g, (char) => char.toUpperCase()) : "";
}

export function capitalizeWord(str) {
  return typeof str === "string"
    ? str.replace(/\b\w/g, (char) => char.toUpperCase())
    : "";
}

export function dateFormateDDTT(dateValue) {
  const istTime = moment(dateValue)
    .tz("Asia/Kolkata")
    .format("YYYY-MM-DD HH:mm:ss A");
  return istTime;
}

export function formatDate(dateString) {
  if (!dateString) {
    return "N/A";
  }

  const joinedOnDate = new Date(dateString);
  const options = { day: "numeric", month: "short", year: "numeric" };
  return joinedOnDate.toLocaleDateString("en-US", options);
}

// age calculate
export function calculateAge(dateOfBirth) {
  if (!dateOfBirth) {
    return null;
  }
  const dob = new Date(dateOfBirth);
  if (isNaN(dob.getTime())) {
    return null;
  }
  const now = new Date();
  let age = now.getFullYear() - dob.getFullYear();
  if (
    now.getMonth() < dob.getMonth() ||
    (now.getMonth() === dob.getMonth() && now.getDate() < dob.getDate())
  ) {
    age--;
  }

  return age;
}

export function hasAccessTo(accessList, access) {
  return accessList.includes(access);
}

export function getCurrentDateTime() {
  const dateObj = new Date();

  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, "0");
  const day = String(dateObj.getDate()).padStart(2, "0");
  const hours = String(dateObj.getHours()).padStart(2, "0");
  const minutes = String(dateObj.getMinutes()).padStart(2, "0");
  const seconds = String(dateObj.getSeconds()).padStart(2, "0");

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}
export function formatDateToDDMMYYYY(date) {
  if (!date) return "";
  const [year, month, day] = date.split("-");
  return `${day}-${month}-${year}`;
}
export const getMaxDate = () => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const maxYear = currentYear - 18;
  const maxDate = `${maxYear}-${("0" + (currentDate.getMonth() + 1)).slice(
    -2
  )}-${("0" + currentDate.getDate()).slice(-2)}`;
  return maxDate;
};
export const getMinYear = () => {
  const currentYear = new Date().getFullYear();
  return `${currentYear - 100}-01-01`;
};
export function getDateSevenDaysAgo(date) {
  const sevenDaysAgo = new Date(date);
  sevenDaysAgo.setDate(date.getDate() - 7);
  return sevenDaysAgo;
}

export function modifyDate(type, value) {
  const newDate = new Date();

  if (type === "add") {
    newDate.setDate(newDate.getDate() + value);
  } else if (type === "sub") {
    newDate.setDate(newDate.getDate() - value);
  }
  return newDate;
}
export function modifyYear(type, value) {
  const newDate = new Date();

  if (type === "add") {
    newDate.setFullYear(newDate.getFullYear() + value);
  } else if (type === "sub") {
    newDate.setFullYear(newDate.getFullYear() - value);
  }
  return newDate;
}

export const addOneyear = () => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const maxYear = currentYear + 1;
  const getnextyear = new Date(maxYear, 0, 2);
  const nextyear = getnextyear.toISOString().slice(0, 10);

  return nextyear;
};

export const addYear = (Year) => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const maxYear = currentYear + Year;
  const getnextyear = new Date(maxYear, 0, 2);
  const nextyear = getnextyear.toISOString().slice(0, 10);
  return nextyear;
};

export const formatDated = (date) => {
  const d = new Date(date);
  const month = ("0" + (d.getMonth() + 1)).slice(-2);
  const day = ("0" + d.getDate()).slice(-2);
  return d.getFullYear() + "-" + month + "-" + day;
};

// export const decryptedAdminID = () => {
//   const adminID = localStorage.getItem("adminID");
//   const secretKey = "your-secret-key"; // Use a consistent secret key for both encryption and decryption

//   if (adminID) {
//     // Decrypt the admin ID
//     const bytes = CryptoJS.AES.decrypt(adminID, secretKey);
//     const decryptedAdminID = bytes.toString(CryptoJS.enc.Utf8);

//     //console.log("Decrypted Admin ID:", decryptedAdminID);
//     return decryptedAdminID; // Return the decrypted ID
//   }

//   return null;
// };
export const decryptedAdminID = () => {
  const encryptedAdminID = localStorage.getItem("adminID");

  if (encryptedAdminID) {
    const secretKey = "your-secret-key";

    try {
      const bytes = CryptoJS.AES.decrypt(encryptedAdminID, secretKey);
      const decryptedAdminID = bytes.toString(CryptoJS.enc.Utf8);
      return decryptedAdminID || null;
    } catch (error) {
      console.error("Decryption error: ", error);
      return null; // Return null if decryption fails
    }
  }
  return null; // Return null if encryptedAdminID is not found
};

// simply puh?
export const colorPalette = [
  "#180161",
  "#4F1787",
  "#EB3678",
  "#FB773C",
  "#A91079",
  "#FF7D7D",
  "#0B666A",
  "#A686FF",
  "#5D0E41",
  "#FCC8F8",
  "#FF6F5E",
  "#9FB4FF",
  "#84253E",
  "#007965",
  "#9AB3F5",
  "#E0E0E0",
  "#341677",
  "#086972",
  "#F5A623",
  "#1A2B88",
  "#D23F8A",
  "#2D8C3B",
  "#FFD300",
  "#6B1FB3",
  "#B87333",
  "#0C5E8E",
  "#EF476F",
  "#1B998B",
  "#FF4D6D",
  "#FFA0A0",
  "#F29E4C",
  "#007F5F",
  "#423E3E",
  "#BB1B6E",
  "#CA3E47",
  "#FFBC42",
  "#08A045",
  "#6050DC",
  "#FF00A8",
  "#00C2BA",
  "#BCFF00",
  "#0A043C",
  "#29A0B1",
  "#FF70A6",
  "#96CEB4",
  "#00D084",
  "#808080",
  "#F18F01",
  "#034748",
  "#1B3B6F",
];

export const getLast7Weeks = () => {
  const weeks = [];
  const currentDate = new Date();
  const dayOfWeek = currentDate.getDay(); // Sunday is 0, Monday is 1, etc.
  const startOfWeek = new Date(
    currentDate.setDate(currentDate.getDate() - dayOfWeek)
  ); // Start of the current week

  // Loop through the last 7 weeks
  for (let i = 0; i < 7; i++) {
    const startDate = new Date(startOfWeek);
    startDate.setDate(startOfWeek.getDate() - i * 7); // Move back to previous week
    const endDate = new Date(startDate);
    endDate.setDate(startDate.getDate() + 6); // Set end date of the week

    // Format the dates as "YYYY-MM-DD"
    const startFormatted = startDate.toISOString().split("T")[0];
    const endFormatted = endDate.toISOString().split("T")[0];

    weeks.push({ startDate: startFormatted, endDate: endFormatted });
  }

  return weeks;
};

export const formatAmount = (amount) => {
  if (!amount) return "0"; // Handle null or undefined
  return amount.toString().replace(/\.00$/, "");
};

export const formatToYYYYMMDD = (date) => {
  if (!date) return "";
  const [day, month, year] = date.split("-");
  return `${year}-${month}-${day}`;
};

  export const formatCurrency = (amount) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "INR",
      minimumFractionDigits: 2,
    }).format(amount || 0);
  };

// Function to convert YYYY-MM-DD to DD-MM-YYYY (for display)
export const formatToDDMMYYYY = (date) => {
  if (!date) return "";
  const [year, month, day] = date.split("-");
  return `${day}-${month}-${year}`;
};

export function calculatePendingDays(pendingDateString) {
  const pendingDate = new Date(pendingDateString);
  const currentDate = new Date();

  // Extract only the year, month, and day for comparison
  const pendingDateOnly = new Date(
    pendingDate.getFullYear(),
    pendingDate.getMonth(),
    pendingDate.getDate()
  );
  const currentDateOnly = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    currentDate.getDate()
  );

  const differenceInMilliseconds = pendingDateOnly - currentDateOnly;
  const differenceInDays = Math.floor(
    differenceInMilliseconds / (1000 * 60 * 60 * 24)
  );

  if (differenceInDays === 0) {
    return "Today";
  } else if (differenceInDays === 1) {
    return "1 day ago";
  } else if (differenceInDays > 1) {
    return `${differenceInDays} days ago`;
  } else {
    // For future dates
    return `${Math.abs(differenceInDays)} day${
      Math.abs(differenceInDays) > 1 ? "s" : ""
    } ago`;
  }
}

// ✅ To get only decimal part (e.g., 0.70)
export function getRoundOffAmount(amount) {
  if (typeof amount !== "number") {
    amount = parseFloat(amount);
  }

  const integerPart = Math.trunc(amount);
  const roundOff = (amount - integerPart).toFixed(2);
  return parseFloat(roundOff);
}

// ✅ To get integer part (e.g., 58309.00)
export function getBalanceDue(amount) {
  if (typeof amount !== "number") {
    amount = parseFloat(amount);
  }

  const integerPart = Math.trunc(amount);
  return integerPart;
}

// ✅ For formatting numbers with commas
export function formatAmountCalculate(amount) {
  if (typeof amount !== "number") {
    amount = parseFloat(amount);
  }
  return amount.toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}



export const interviewStatusOptions = [
  { label: "Interview - Tentative Date", value: "Interview - Tentative Date" },
  { label: "Interview Scheduled", value: "Interview Scheduled" },
  { label: "Interview Rescheduled", value: "Interview Rescheduled" },
  { label: "Interview - Attended", value: "Interview - Attended" },
  { label: "Interview - Not Attended", value: "Interview - Not Attended" },
  {
    label: "Interview Attending Not Interested",
    value: "Interview Attending Not Interested",
  },
  { label: "Interview - Offer Accepted", value: "Interview - Offer Accepted" },
  { label: "Interview - Offer Rejected", value: "Interview - Offer Rejected" },
  { label: "Awaiting By Employer", value: "Awaiting By Employer" },
  {
    label: "Interview - Awaiting by candidate",
    value: "Interview - Awaiting by candidate",
  },
  { label: "Joining - Tentative Date", value: "Joining - Tentative Date" },
  {
    label: "Joining Follow Up 1 Confirmed",
    value: "Joining Follow Up 1 Confirmed",
  },
  {
    label: "Joining Follow Up 2 Confirmed",
    value: "Joining Follow Up 2 Confirmed",
  },
  { label: "Follow Up 1 Not Interested", value: "Follow Up 1 Not Interested" },
  { label: "Follow Up 2 Not Interested", value: "Follow Up 2 Not Interested" },
  { label: "Joined Confirmed", value: "Joined Confirmed" },
  { label: "Joining Day Not Interested", value: "Joining Day Not Interested" },
];

// utils/dateUtils.js

export const convertDateYYYYMMDd = (date) => {
  return date.toISOString().slice(0, 10);
};

export const getCurrentMonthRange = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth(); // 0-indexed

  const firstDay = new Date(year, month, 1);
  const lastDay = new Date(year, month + 1, 0);

  return {
    startDate: convertDateYYYYMMDD(firstDay),
    endDate: convertDateYYYYMMDD(lastDay),
  };
};

export const getPercentageColor = (percentage, type = "light") => {
  if (type === "dark") {
    if (percentage <= 33) return "#ff4d4d"; // Dark Red (Warning)
    if (percentage <= 66) return "#ffa500"; // Dark Orange (Caution)
    if (percentage <= 100) return "#4caf50"; // Dark Green (Appreciation)
    return "#6c63ff"; // Dark Purple (Overachievement)
  } else {
    if (percentage <= 33) return "#ffeaea"; // Light Red (Warning)
    if (percentage <= 66) return "#fff7e0"; // Light Orange (Caution)
    if (percentage <= 100) return "#eafbe7"; // Light Green (Appreciation)
    return "#e6e6ff"; // Light Purple (Overachievement)
  }
};

export const sources = [
  // "ALL",
  "Meta Ads Form",
  "Meme Page",
  "Whatsapp Channel",
  "Google ads",
  "Reference",
  "Meta lead",
  "Naukri",
  "Retention",
  "Indeed",
  "Others",
  "Website",
  "Workindia",
  "Quikr",
  "Admin"
  // "Sri Andal Nachiyar Polytechnic",
];

export const empSource = [
  "Email",
  "Field Visit",
  "YouTube",
  "Facebook",
  "Instagram",
  "WhatsApp",
  "LinkedIn",
  "Google Search",
  "Recommended by a friend or colleague",
  "Recommended by Industrial Association",
  "Taizo staff member",
  "Others",
];

export const mailFromOptions = [
  { id: 2, name: "Sowmiya" },
  { id: 7, name: "Saravanan" },
  { id: 27, name: "Thahaniya Begam" },
  { id: 28, name: "Mounika" },
  { id: 31, name: "Nikath Fathima" },
  { id: 45, name: "Bhagyalaksmi" },
  { id: 50, name: "Bharathi" },
];


export const currentlyWorkingReasons = [
  { value: "Higher Salary", label: "Higher Salary" },
  { value: "Higher Position", label: "Higher Position" },
  { value: "Contract Ending Soon", label: "Contract Ending Soon" },
  { value: "Job Location", label: "Job Location" },
  { value: "Shift Timings", label: "Shift Timings" },
  { value: "Work Hours", label: "Work Hours" },
  { value: "No Company Accommodation", label: "No Company Accommodation" },
  { value: "Salary Not Released On Time", label: "Salary Not Released On Time" },
  { value: "Promised Salary Not Provided", label: "Promised Salary Not Provided" },
  { value: "No Salary Increment", label: "No Salary Increment" },
  { value: "Partiality in Management", label: "Partiality in Management" },
  { value: "Poor Food Quality", label: "Poor Food Quality" },
  { value: "Company Not Well Established", label: "Company Not Well Established" },
  { value: "Company Size Not Suitable", label: "Company Size Not Suitable" },
  { value: "No Career Growth", label: "No Career Growth" },
  { value: "Personal or Family Issues", label: "Personal or Family Issues" },
  { value: "Parents’ Health Problems", label: "Parents’ Health Problems" },
  { value: "Not Interested in Current Work", label: "Not Interested in Current Work" },
  { value: "Other Reason Not Listed", label: "Other Reason Not Listed" },
];


export const currentlyNotWorkingReasons = [
  { value: "Contract/Project Ended", label: "Contract/Project Ended" },
  { value: "Company Closed", label: "Company Closed" },
  { value: "Health Issues", label: "Health Issues" },
  { value: "Job Location", label: "Job Location" },
  { value: "Salary Not Released On Time", label: "Salary Not Released On Time" },
  { value: "Promised Salary Not Provided", label: "Promised Salary Not Provided" },
  { value: "No Salary Increment", label: "No Salary Increment" },
  { value: "Partiality in Management", label: "Partiality in Management" },
  { value: "Poor Food Quality", label: "Poor Food Quality" },
  { value: "No Company Accommodation", label: "No Company Accommodation" },
  { value: "Company Not Well Established", label: "Company Not Well Established" },
  { value: "No Career Growth", label: "No Career Growth" },
  { value: "Location Too Far", label: "Location Too Far" },
  { value: "Personal or Family Issues", label: "Personal or Family Issues" },
  { value: "Worked for Many Years (Seeking Change)", label: "Worked for Many Years (Seeking Change)" },
  { value: "Not Interested in Current Work", label: "Not Interested in Current Work" },
  { value: "Other Reason", label: "Other Reason" },
];
export const extractAdminIds = (res) => {
  if (!res?.data) return [];

  return res.data.map((item) => item.admin_id);
};


// utils/getStageBadge.js

export const getSubStageBadge = (text = "") => {
  const map = {
    "Call Not Attended": {
      label: "CNA",
      bg: "#fdecea",
      color: "#d32f2f",
    },
    "Awaiting Resume": {  
      label: "Await",
      bg: "#e3f2fd",
      color: "#1976d2",
    },
    "Not Qualified": {
      label: "NQ",
      bg: "#f3e5f5",
      color: "#7b1fa2",
    },
    // "Interview Attending": {
    //   label: "Attending",
    //   bg: "#e8f5e9",
    //   color: "#2e7d32",
    // },
    "Interview Not Attended": {
      label: "Interview NA",
      bg: "#fff3e0",
      color: "#ef6c00",
    },
    "Rescheduled": {
      label: "Rescheduled",
      bg: "#ede7f6",
      color: "#5e35b1",
    },
    "Waiting By Employer": {
      label: "Await",
      bg: "#e0f7fa",
      color: "#00838f",
    },
    "Replacement": {
      label: "Replacement",
      bg: "#fbe9e7",
      color: "#bf360c",
    },
    "Offer Released": {
      label: "Offer Released",
      bg: "#e8f5e9",
      color: "#169c50",
    },
    "Will Join": {
      label: "Will Join",
      bg: "#f1f8e9",
      color: "#558b2f",
    },
  };

  if (map[text]) return map[text];

  // fallback
  return {
    label: text
      .split(" ")
      .map((w) => w[0])
      .join("")
      .toUpperCase(),
    bg: "#eeeeee",
    color: "#333",
  };
};

export const getMainStageBadge = (stage = "") => {
  const map = {
    Scheduled: {
      label: "Scheduled",
      bg: "#E3F2FD",
      color: "#1565C0", // Blue
    },
    Attended: {
      label: "Attended",
      bg: "#E8F5E9",
      color: "#2E7D32", // Green
    },
    Selected: {
      label: "Selected",
      bg: "#D0F8CE",
      color: "#1B5E20", // Dark Green
    },
    "Offer Accepted": {
      label: "Offer Accepted",
      bg: "#E0F7FA",
      color: "#00838F", // Cyan
    },
    Joined: {
      label: "Joined",
      bg: "#F1F8E9",
      color: "#33691E", // Olive Green
    },
    "Not Interested": {
      label: "Not Interested",
      bg: "#FFEBEE",
      color: "#C62828", // Red
    },
    Left: {
      label: "Left",
      bg: "#FFF3E0",
      color: "#EF6C00", // Orange
    },
    "Not Selected": {
      label: "Not Selected",
      bg: "#FFF8E1",
      color: "#F9A825", // Yellow
    },
    "Offer Rejected": {
      label: "Offer Rejected",
      bg: "#FCE4EC",
      color: "#AD1457", // Pink
    },
    "Lead Lost": {
      label: "Lead Lost",
      bg: "#ECEFF1",
      color: "#455A64", // Grey
    },
  };

  return map[stage] || null;
};
export const formatFullDateTime = (dateString) => {
  if (!dateString) return "";

  const date = new Date(dateString);

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  const weekday = date.toLocaleDateString("en-US", {
    weekday: "long",
  });

  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");

  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12; // convert to 12-hour

  return `${day}/${month}/${year} ${weekday} ${hours}:${minutes} ${ampm}`;
};

  export const hideDateFor = ["Call Not Attended", "Undo"];

  export const showReasonFor = [
    "Call Not Attended",
    "Not Qualified",
    "Interview Not Attended",
    "Interview Not Selected",
    "Offer Rejected",
    "Not Interested",
  ];


 export const formatDescription = (text) => {
  try {
    const jsonMatch = text.match(/{.*}/);

    if (jsonMatch) {
      const parsed = JSON.parse(jsonMatch[0]);

      const company = parsed.companyName || "";
      const city = parsed.city || "";

      const replacement = `${company}${company && city ? " - " : ""}${city}`;

      // Replace JSON with formatted text
      return text.replace(jsonMatch[0], replacement);
    }

    return text;
  } catch (err) {
    return text;
  }
};

export const timeRemove = (description) => {
  if (!description) return '';
  
  // This regex looks for date patterns followed by 00:00:00 and removes the time part
  let cleaned = description.replace(/\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}/g, (match) => {
    // If it ends with 00:00:00, just return the date part
    if (match.endsWith('00:00:00')) {
      return match.split(' ')[0];
    }
    return match;
  });
  
  cleaned = cleaned.replace(/ 00:00:00/g, '');
  
  return cleaned;
};

export const STAGE_OPTIONS = [
  { id: 8, name: "Interview Scheduled" },
  { id: 14, name: "Interview Attended" },
  { id: 18, name: "Selected" },
  { id: 21, name: "Not Selected" },
  { id: 22, name: "Offer Accepted" },
  { id: 25, name: "Offer Rejected" },
  { id: 27, name: "Joined" },
  { id: 29, name: "Left" },
  { id: 30, name: "Lead Lost" },
];

export const renderInterviewDate = (interviewDate) => {
  if (!interviewDate) return null;

  const today = new Date();
  const givenDate = new Date(interviewDate);

  // Remove time part for accurate comparison
  const todayOnly = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate()
  );

  const givenOnly = new Date(
    givenDate.getFullYear(),
    givenDate.getMonth(),
    givenDate.getDate()
  );

  const diffTime = givenOnly.getTime() - todayOnly.getTime();
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

  // ✅ TODAY
  if (diffDays === 0) {
    return (
      <img
        src={greengif}
        alt="today"
        width="40px"
        height="25px"
        style={{ marginTop: "2px" }}
      />
    );
  }

  // ✅ YESTERDAY
  if (diffDays === -1) {
    return <b style={{ fontSize: "12px" }}>Yesterday</b>;
  }

  // ✅ TOMORROW
  if (diffDays === 1) {
    return <b style={{ fontSize: "12px" }}>Tomorrow</b>;
  }

  // ✅ PAST (more than 1 day ago)
  if (diffDays < -1) {
    return (
      <b style={{ fontSize: "12px" }}>
        {Math.abs(diffDays)} days ago
      </b>
    );
  }

  // ✅ FUTURE (more than 1 day ahead → show formatted date)
  return (
    <b style={{ fontSize: "12px" }}>
      {givenDate.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })}
    </b>
  );
};
export  const getInitials = (name) => {
    if (!name) return '';
    return name.split(' ').map(word => word[0]).join('').toUpperCase().slice(0, 2);
  };


 // Helper functions
 export const formatDates = (date) => {
   const d = new Date(date);
   const year = d.getFullYear();
   const month = String(d.getMonth() + 1).padStart(2, '0');
   const day = String(d.getDate()).padStart(2, '0');
   return `${year}-${month}-${day}`;
 };
 
 export const getDefaultDateRange = (status) => {
   const today = new Date();
   const formattedToday = formatDates(today);
   
   const oneWeekAgo = new Date(today);
   oneWeekAgo.setDate(today.getDate() - 7);
   const formattedOneWeekAgo = formatDates(oneWeekAgo);
   
   // Get yesterday's date for COMPLETED
   const yesterday = new Date(today);
   yesterday.setDate(today.getDate() - 1);
   const formattedYesterday = formatDates(yesterday);
   
   switch(status) {
     case 'TODO':
       return { startDate: formattedToday, endDate: formattedToday };
     case 'PENDING':
       return { startDate: formattedOneWeekAgo, endDate: formattedToday };
     case 'COMPLETED':
       // return { startDate: formattedOneWeekAgo, endDate: formattedYesterday }; 
        return { startDate: formattedOneWeekAgo, endDate: formattedToday };
     default:
       return { startDate: "", endDate: "" };
   }
 };
 
 export const convertPriority = (apiPriority) => {
   switch(apiPriority) {
     case 'CRITICAL': return 'critical';
     case 'HIGH': return 'high';
     case 'MEDIUM': return 'medium';
     case 'LOW': return 'low';
     default: return 'critical';
   }
 };
 
 export const convertPriorityToAPI = (priority) => {
   if (!priority) return null;
   switch(priority.toLowerCase()) {
     case 'critical': return 'CRITICAL';
     case 'high': return 'HIGH';
     case 'medium': return 'MEDIUM';
     case 'low': return 'LOW';
     default: return priority.toUpperCase();
   }
 };
 
 export const formatDisplayDate = (dateString) => {
   if (!dateString) return '';
   const date = new Date(dateString);
   return date.toLocaleDateString('en-GB', { 
     day: 'numeric', 
     month: 'short', 
     year: 'numeric' 
   });
 };

 export   const stageMenuOptions = {
    Scheduled: [
      { label: "Interview Card" },
      { label: "Interview Attended", stage_id: 14 },
      { label: "Interview Not Attended", sub_stage_id: 13 },
      { label: "Call Not Attended", sub_stage_id: 9 },
      { label: "Reschedule Interview", sub_stage_id: 12 },
      { label: "Not Interested", stage_id: 26 },
      { label: "Create Follow-up" },
    ],
    Attended: [
      { label: "Selected", stage_id: 18 },
      { label: "Not Selected", stage_id: 21 },
      { label: "Await Employer", sub_stage_id: 17 },
      { label: "Call Not Attended", sub_stage_id: 15 },
      { label: "Not Interested", stage_id: 26 },
      { label: "Offer Rejected", stage_id: 25 },
      { label: "Undo", stage_id: 8 },
      { label: "Create Follow-up" },
    ],
    Selected: [
      { label: "Offer Accepted", stage_id: 22 },
      { label: "Offer Rejected", stage_id: 25 },
      { label: "Call Not Attended", sub_stage_id: 19 },
      { label: "Not Interested", stage_id: 26 },
      { label: "Undo", stage_id: 14 },
      { label: "Create Follow-up" },
    ],
    "Offer Accepted": [
      { label: "Offer Rejected", stage_id: 25 },
      { label: "Call Not Attended", sub_stage_id: 23 },
      { label: "Will join", sub_stage_id: 34 },
      { label: "Joined", stage_id: 27 },
      { label: "Undo", stage_id: 18 },
      { label: "Create Follow-up" },
    ],
    Joined: [
      { label: "Left", stage_id: 29 },
      { label: "Undo", stage_id: 22 },
      { label: "Create Follow-up" },
    ],
    // "Not Interested": [{ label: "Undo", stage_id: 8 }],
  };